<template>
  <el-form
    :model="form"
    :disabled="disabledForm"
    ref="form"
  >
    <div class="row">
      <div class="col-md-3 col-sm-6 col-12">
        <el-form-item
          :label="L10n('region')"
          prop="regionID"
          :rules="getValidationRule('required')"
          class="material-style">
          <select-response
            :model.sync="form.regionID"
            @update:model="updateModelItem('regionID', { required: true })"
            :data="dataSourceRegions.records"
            :isLoading="dataSourceRegions.loading"
          ></select-response>
        </el-form-item>
      </div>
      <div class="col-md-3 col-sm-6 col-12">
        <el-form-item
          :label="L10n('aircraft-model')"
          :rules="getValidationRule('required')"
          prop="aircraftID"
          class="material-style">
          <select-response-auto-complete
            :model.sync="form.aircraftID"
            @update:model="updateModelItem('aircraftID', { required: true })"
            api="Aircrafts/GetAllDynamic"
            :fields="{id: 'id', title: 'aircraftModel'}"
          ></select-response-auto-complete>
        </el-form-item>
      </div>
    </div>
    <div class="row">
      <div class="col-md-3 col-sm-6 col-12">
        <el-form-item
          :label="L10n('engine')"
          prop="engine"
          class="material-style">
          <el-input
            ref="seventhField"
            :value="form.engine"
            @input="form.engine = valueTrimLeft($event)"
            @change="updateModelItem('engine', { required: false })"/>
        </el-form-item>
      </div>
      <div class="col-md-3 col-sm-6 col-12">
        <el-form-item
          :label="L10n('unit')"
          prop="unit"
          class="material-style">
          <el-input
            ref="seventhField"
            :value="form.unit"
            @input="form.unit = valueNumber($event)"
            @change="updateModelItem('unit', { required: false })"/>
        </el-form-item>
      </div>
    </div>
  </el-form>
</template>

<script>
import Form from '@/components/Form/Form'

export default {
  name: 'FormForwarders',
  mixins: [Form],
  computed: {
    dataSourceRegions () {
      return this.API('Regions/GetAllDynamic?select=id,title')
    }
  }
}
</script>
